import React from "react";
import { RaisedButton } from "material-ui";

import { capitalize, isApp } from "../../util";

const STYLES = {
  container: {
    textAlign: "center",
    padding: "2em 2em 1.5em",
    marginBottom: "0.5em",
    whiteSpace: "nowrap",
    overflowX: "auto"
  }
};

class ModeSwitcher extends React.Component {
  constructor(props) {
    super(props);
    this._makeButton = this._makeButton.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    tenant: React.PropTypes.object
  };

  _makeButton({ label, value, position, href, onClick }) {
    let isSelected = value === this.props.value,
      borderRadiusStyle =
        position === "left"
          ? "10px 0 0 10px"
          : position === "right"
            ? "0 10px 10px 0"
            : 0;

    return (
      <RaisedButton
        key={value}
        label={label}
        primary={isSelected}
        href={href}
        style={{
          verticalAlign: href ? 1 : undefined,
          borderRadius: borderRadiusStyle,
          borderRight: position !== "right" && "1px solid #ccc"
        }}
        buttonStyle={{ borderRadius: borderRadiusStyle }}
        overlayStyle={{ borderRadius: borderRadiusStyle }}
        onClick={onClick}
        className={`eventive-mode-switcher__${value}`}
      />
    );
  }

  render() {
    let { value, style } = this.props,
      showFilmGuide = this.context.appSettings.film_guide_enabled,
      showPasses =
        this.context.tenant.marquee_enabled &&
        this.context.tenant.passes_enabled &&
        this.context.tenant.display_passes,
      showMemberships =
        this.context.tenant.marquee_enabled &&
        this.context.tenant.memberships_enabled &&
        this.context.tenant.display_memberships,
      // showPasses =
      //   this.context.tenant.marquee_enabled &&
      //   this.context.tenant.passes_enabled &&
      //   this.context.tenant.memberships_enabled ? this.context.tenant.display_memberships : this.context.tenant.display_passes,
      showVirtualFestival =
        this.context.appSettings.enable_virtual_festival &&
        !this.context.tenant.virtual_festival_hide_tab_on_main_site,
      showSchedule =
        !showVirtualFestival || this.context.appSettings.schedule_enabled;

    // BlackStar Temp
    if (this.context.tenant.event_bucket === "65e20cef795dc60088423e76" && isApp()) {
      showVirtualFestival = false;
    }

    const buttons = [
      showSchedule
        ? {
          label: this.context.tenant.marquee_enabled
            ? "Now playing"
            : capitalize(this.context.tenant.display_schedule) || "Schedule",
          value: this.context.tenant.marquee_enabled ? "marquee" : "schedule",
          onClick: () => {
            if (this.context.router.location.pathname !== "/schedule") {
              this.context.router.push({ pathname: "/schedule" });
            }
          }
        }
        : null,
      showVirtualFestival
        ? {
          label:
            this.context.tenant.virtual_festival_tab_label ||
            "Virtual festival",
          value: "virtual-festival",
          onClick: () => {
            window.open(
              this.context.appSettings.urls.virtual_festival,
              "_blank"
            );
          }
        }
        : null,
      showPasses && this.context.tenant.passes_enabled
        ? {
          label: `${capitalize(this.context.tenant.display_passes, true)}`,
          value: "passes",
          onClick: () => {
            if (this.context.router.location.pathname !== "/passes/buy") {
              this.context.router.push({ pathname: "/passes/buy" });
            }
          }
        }
        : null,
      showMemberships && this.context.tenant.memberships_enabled
        ? {
          label: `${capitalize(this.context.tenant.display_memberships, true)}`,
          value: "memberships",
          onClick: () => {
            if (this.context.router.location.pathname !== "/memberships/buy") {
              this.context.router.push({ pathname: "/memberships/buy" });
            }
          }
        }
        : null,
      showFilmGuide
        ? {
          label: this.context.tenant.display_film_guide || "Film guide",
          value: "film-guide",
          onClick: () => {
            if (this.context.router.location.pathname !== "/films") {
              this.context.router.push({ pathname: "/films" });
            }
          }
        }
        : null
    ].filter(x => !!x);

    if (buttons.length < 2) {
      return <div style={STYLES.container} />;
    }

    return (
      <div
        style={Object.assign({}, STYLES.container, style)}
        className={typeof value === "string"
          ? `Eventive--ModeSwitcher Eventive--ModeSwitcher--${value.split(' ').join('_')}`
          : "Eventive--ModeSwitcher"}
      >
        {buttons.map((opts, i) => {
          return this._makeButton({
            ...opts,
            position:
              i === 0 ? "left" : i === buttons.length - 1 ? "right" : "center"
          });
        })}
      </div>
    );
  }
}

export default ModeSwitcher;



// WEBPACK FOOTER //
// ./src/app/components/partials/mode-switcher.jsx